import React, {useLayoutEffect, useState, useEffect} from 'react';
import {
    Button,
    Card,
    CardBody,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader, Input,
    Typography
} from "@material-tailwind/react";
import MapComponent from "../../shared/map_component";
import {NumericFormat} from "react-number-format";
import axios from "axios";

const ValuesAdjustment = ({lot, movement}) => {
    const [loaderActive, setLoaderActive] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [error, setError] = useState(null);

    const [constructions, setConstructions] = useState([]);
    const [lands, setLands] = useState([]);
    const [lotNotes, setLotNotes] = useState("");
    const [constructionValue, setConstructionValue] = useState(null);
    const [landValue, setLandValue] = useState(null);
    const [landsAdjustment, setLandsAdjustment] = useState({});
    const [constAdjustment, setConstAdjustment] = useState({});

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    }

    const handleReset = () => {
        window.location.replace('movements');
    };

    useLayoutEffect(() => {
        async function fetchLotDetails() {
            try {
                const [constructionsResponse, landResponse] = await Promise.all([
                    fetch(`/lots/${lot.parcel_code}/constructions.json`),
                    fetch(`/lots/${lot.parcel_code}/land.json`),
                ]);

                if (constructionsResponse.ok) {
                    const constructionsData = await constructionsResponse.json();
                    setConstructions(constructionsData);
                    const constValue = constructionsData ? constructionsData.reduce((acc, construction) => acc + construction.value, 0) + lot.special_facilities_value : 0;
                    setConstructionValue(constValue.toFixed(2));

                    console.log(constructionsData);

                    const constAssignments = {};
                    constructionsData.forEach((construction) => {
                        constAssignments[construction.construction_id] = {
                            id: construction.construction_id,
                            value: construction.value,
                        };
                    });
                    setConstAdjustment(constAssignments);
                } else {
                    console.log("No se encontraron construcciones para este código.");
                }

                if (landResponse.ok) {
                    const landData = await landResponse.json();
                    setLands(landData);
                    const landsValue = landData ? landData.reduce((acc, land) => acc + (land.value), 0) : 0;
                    setLandValue(landsValue.toFixed(2));

                    const landAssignments = {};
                    landData.forEach((land) => {
                        landAssignments[land.id] = {
                            id: land.id,
                            value: land.value,
                        };
                    });
                    setLandsAdjustment(landAssignments);
                } else {
                    console.log("No se encontraron terrenos para este código.");
                }

            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        fetchLotDetails();
        setLotNotes(lot.notes);
    }, [lot]);

    useEffect(() => {
        console.log('lands mod', landsAdjustment);
        console.log('const mod', constAdjustment);
    }, [landsAdjustment, constAdjustment]);

    const handleConstructionChange = (id, value) => {
        setConstAdjustment((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                value: Number(value),
            },
        }));
    };

    const handleLandChange = (id, value) => {
        setLandsAdjustment((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                value: Number(value),
            },
        }));
    };

    const handleSubmit = async () => {
        try {
            setLoaderActive(true);
            const response = await axios.post(`lots/${lot.parcel_code}/adjustment.json`, {
                lot: {
                    calculate_qualification: true,
                    notes: lotNotes,
                    reason_type_id: movement.id,
                },
                ...(Object.keys(landsAdjustment).length > 0 && {
                    lands: Object.values(landsAdjustment).map((land) => ({
                        id: land.id,
                        value: land.value,
                    })),
                }),
                ...(Object.keys(constAdjustment).length > 0 && {
                    constructions: Object.values(constAdjustment).map((c) => ({
                        id: c.id,
                        value: c.value,
                    })),
                }),
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });
            if (response.status === 200) {
                setOpenEndDialog(true);
                const url = `/lots/${lot.parcel_code}/print_movement.pdf`;
                window.open(url, '_blank');
                setLoaderActive(false);
            } else {
                setError('Error al actualizar dirección del predio. Verifica los datos.');
                setLoaderActive(false);
            }
        } catch (err) {
            setError('Error al guardar. Verifica los datos.');
            setLoaderActive(false);
        }
    };

    const totalConstArea = constructions.reduce((acc, construction) => acc + (construction.area), 0);
    const totalConstValue = constructions.reduce((acc, construction) => acc + construction.value, 0);
    const totalLandArea = lands ? lands.reduce((acc, land) => acc + (land.area), 0) : 0;
    const totalLandValue = lands ? lands.reduce((acc, land) => acc + (land.value), 0) : 0;

    const valuationConst = constructions.reduce((acc, construction) => acc + construction.valuation, 0);
    const valuationLand = lands ? lands.reduce((acc, land) => acc + (land.value), 0) : 0;
    const valuatedQualification = valuationLand + valuationConst;

    const adjustedLandVal = landsAdjustment ? Object.values(landsAdjustment).reduce((acc, land) => acc + (land.value), 0) : 0;
    const adjustedConstVal = constAdjustment ? Object.values(constAdjustment).reduce((acc, construction) => acc + (construction.value), 0) : 0;
    const newQualification = Number(adjustedConstVal) + Number(adjustedLandVal) + lot.special_facilities_value;

    const getUnit = lot.lot_location_type === 'URBANO' ? <>m<sup>2</sup></> : <>ha</>;

    return (
        <>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información del predio
                </h6>
                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        {lot && (
                            <CardBody className='p-0'>
                                <div className="w-full mb-4 bg-gray-100">
                                    {(lot.latitude && lot.longitude) && (
                                        <MapComponent
                                            parcel_code={lot.parcel_code}
                                            latitude={lot.latitude}
                                            longitude={lot.longitude}
                                        />
                                    )}
                                </div>
                                <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Clave catastral
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.parcel_code}
                                        </Typography>
                                    </div>
                                </div>
                                <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Dirección
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.road_name}{lot.ext_num ? " #" + lot.ext_num : ""}, {lot.neighborhood_name},
                                            C.P. {lot.postal_code}
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Referencias
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.address_references === null ? '' : lot.address_references}
                                        </Typography>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    REGISTRO DEL PREDIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    R.P.P.
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Insc.
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.inscription}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Folio
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.folio}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Libro
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.book}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha efecto
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Bim
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_bimester}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Año
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.effective_year}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='py-2'>
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                                >
                                                    Fecha exento
                                                </Typography>
                                                <div className='flex flex-row gap-4 w-full text-center'>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año inicio
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.start_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                    <div className='flex w-full gap-1'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Bim. fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_bimester}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Año fin
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.end_exempt_year}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                    PROPIETARIO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <div className='py-2'>
                                                {lot.contributor_type === 'P' ? (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Nombre
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido paterno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.parental_last_name}
                                                            </Typography>
                                                        </div>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Apellido Materno
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.maternal_last_name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='flex flex-row gap-4 w-full text-center'>
                                                        <div className='flex flex-col w-full'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Razón social
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.name}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className='flex flex-row gap-4 mt-4 w-full text-center'>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Dirección
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.contributor_street}
                                                            {lot.contributor_ext_num ? " #" + lot.contributor_ext_num : ""}
                                                            {lot.contributor_neighborhood ? ', ' + lot.contributor_neighborhood : ''}
                                                            {lot.contributor_postal_code ? ', C.P. ' + lot.contributor_postal_code : ''}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Teléfono
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.phone ? lot.phone : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                    <div className='flex flex-col w-full'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            RFC
                                                        </Typography>
                                                        <Typography
                                                            variant="paragraph"
                                                            className="font-medium"
                                                        >
                                                            {lot.rfc ? lot.rfc : 'N/A'}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                    TERRENO
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <Card className='w-full border-0' shadow={false}>
                                                <CardBody className='p-0'>
                                                    <table className="w-full min-w-[640px] table-auto border">
                                                        <thead>
                                                        <tr className='bg-gray-50'>
                                                            {["Cve. Val.", "Descripción", "Área", "Valor"].map(
                                                                (el) => (
                                                                    <th
                                                                        key={el}
                                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                    >
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {(!lands || lands.length === 0) ? (
                                                            <tr className="w-full">
                                                                <td colSpan="100%" className="text-center py-3">
                                                                    <strong>El predio no cuenta con terrenos
                                                                        registrados.</strong>
                                                                </td>
                                                            </tr>
                                                        ) : (Object.entries(lands).map(([landId, data], index, array) => {
                                                                const className = `py-3 px-5 ${
                                                                    index === array.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                }`;
                                                                return (
                                                                    <tr key={landId}
                                                                        className="hover:bg-gray-50 cursor-pointer">
                                                                        <td className={className}>{data.rustic_land_value_id ? data.rustic_land_value_id : 'N/A'}</td>
                                                                        <td className={className}>{data.rustic_land_desc ? data.rustic_land_desc : 'Terreno urbano'}</td>
                                                                        <td className={className}>
                                                                            <NumericFormat
                                                                                value={data.area}
                                                                                displayType={'text'}
                                                                                allowLeadingZeros
                                                                                thousandSeparator=","
                                                                            /> {getUnit}
                                                                        </td>
                                                                        <td className={className}>
                                                                            <Input
                                                                                value={landsAdjustment[data.id].value}
                                                                                onChange={(e) => handleLandChange(data.id, e.target.value)}
                                                                                containerProps={{className: '!min-w-0'}}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                        </tbody>
                                                        <tfoot>
                                                        <tr className='border-t'>
                                                            <td colSpan='2'
                                                                className='py-3 px-5 text-right border-r'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Totales
                                                                </Typography>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                <NumericFormat
                                                                    value={totalLandArea.toFixed(2)}
                                                                    displayType={'text'}
                                                                    allowLeadingZeros
                                                                    thousandSeparator=","
                                                                /> {getUnit}
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                <NumericFormat
                                                                    value={adjustedLandVal.toFixed(2)}
                                                                    displayType={'text'}
                                                                    prefix={'$'}
                                                                    thousandSeparator=","
                                                                />
                                                            </td>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-6 border-b-1 border-blue-gray-100"/>
                                <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                    CONSTRUCCIONES
                                </h6>
                                <div className="flex flex-wrap">
                                    <div className="w-full lg:w-12/12 px-0">
                                        <div className="relative w-full mb-3">
                                            <Card className='w-full border-0' shadow={false}>
                                                <CardBody className='p-0'>
                                                    <table className="w-full min-w-[640px] table-auto">
                                                        <thead>
                                                        <tr className='bg-gray-50'>
                                                            {["Cve. Valuación", "Edad", "Sup. Construcción", "Valor"].map(
                                                                (el) => (
                                                                    <th
                                                                        key={el}
                                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                    >
                                                                        <Typography
                                                                            variant="small"
                                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {(!constructions || constructions.length === 0) ? (
                                                            <tr className="w-full">
                                                                <td colSpan="100%" className="text-center py-3">
                                                                    <strong>El predio no cuenta con
                                                                        construcciones.</strong>
                                                                </td>
                                                            </tr>
                                                        ) : (constructions.map((construction, index) => {
                                                                const className = `py-3 px-5 ${
                                                                    index === constructions.length - 1 ? "" : "border-b border-blue-gray-50"
                                                                }`;
                                                                return (
                                                                    <tr key={construction.construction_id}
                                                                        className="hover:bg-gray-50 cursor-pointer">
                                                                        <td className={className}>
                                                                            {construction.construction_value_id}
                                                                        </td>
                                                                        <td className={className}>
                                                                            {construction.construction_devaluation_id.toString()}
                                                                        </td>
                                                                        <td className={className}>
                                                                            {construction.area}
                                                                            <span
                                                                                className='py-2'>m<sup>2</sup></span>
                                                                        </td>
                                                                        <td className={className}>
                                                                            <Input
                                                                                value={constAdjustment[construction.construction_id].value}
                                                                                onChange={(e) => handleConstructionChange(construction.construction_id, e.target.value)}
                                                                                containerProps={{className: '!min-w-0'}}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}

                                                        </tbody>
                                                        <tfoot>
                                                        <tr className='border-t'>
                                                            <td colSpan='2' className='py-3 px-5 text-right border-r'>
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    Totales
                                                                </Typography>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                                <NumericFormat
                                                                    value={totalConstArea}
                                                                    displayType={'text'}
                                                                    thousandSeparator=","
                                                                /> m<sup>2</sup>
                                                            </td>
                                                            <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b border-r'>
                                                                <NumericFormat
                                                                    value={adjustedConstVal.toFixed(2)}
                                                                    displayType={'text'}
                                                                    prefix={'$'}
                                                                    thousandSeparator=","
                                                                />
                                                            </td>
                                                        </tr>
                                                        </tfoot>
                                                    </table>
                                                    <div
                                                        className='flex flex-row gap-4 w-full mt-6 text-center border rounded-md bg-gray-50'>
                                                        <div
                                                            className='flex flex-col w-full p-4 place-content-center'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Instalaciones especiales
                                                            </Typography>
                                                            <div
                                                                className="flex flex-row justify-center gap-1"
                                                            >
                                                                <NumericFormat
                                                                    value={lot.special_facilities_value}
                                                                    displayType={'text'}
                                                                    prefix={'$'}
                                                                    thousandSeparator=","
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            className={`flex flex-col w-full p-4 ${lot.special_facilities && 'border rounded-md bg-gray-50'}`}>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Descripción de instalaciones especiales
                                                            </Typography>
                                                            <Typography
                                                                variant="paragraph"
                                                                className="font-medium"
                                                            >
                                                                {lot.special_facilities}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Valores
                </h6>
                <div className="flex flex-col lg:flex-row gap-4">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">
                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                            Valores anteriores
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Card className='w-full border-0' shadow={false}>
                                        <CardBody className='p-0'>
                                            <table className="w-full min-w-[640px] table-auto border">
                                                <thead>
                                                <tr className='bg-gray-50'>
                                                    {["Valor de terreno", "Valor de construcción", "Valor catastral"].map(
                                                        (el) => (
                                                            <th
                                                                key={el}
                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                            >
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    {el}
                                                                </Typography>
                                                            </th>
                                                        )
                                                    )}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50 hover:bg-gray-50 cursor-pointer">
                                                        <NumericFormat
                                                            value={lot.land_value.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50 hover:bg-gray-50 cursor-pointer">
                                                        <NumericFormat
                                                            value={lot.construction_value.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50 hover:bg-gray-50 cursor-pointer">
                                                        <NumericFormat
                                                            value={lot.qualification.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                            Valores tablas
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Card className='w-full border-0' shadow={false}>
                                        <CardBody className='p-0'>
                                            <table className="w-full min-w-[640px] table-auto border">
                                                <thead>
                                                <tr className='bg-gray-50'>
                                                    {["Valor de terreno", "Valor de construcción", "Valor catastral"].map(
                                                        (el) => (
                                                            <th
                                                                key={el}
                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                            >
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    {el}
                                                                </Typography>
                                                            </th>
                                                        )
                                                    )}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50 hover:bg-gray-50 cursor-pointer">
                                                        <NumericFormat
                                                            value={valuationLand.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50 hover:bg-gray-50 cursor-pointer">
                                                        <NumericFormat
                                                            value={valuationConst.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50 hover:bg-gray-50 cursor-pointer">
                                                        <NumericFormat
                                                            value={valuatedQualification.toFixed(2)}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                            Valores ajustados
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Card className='w-full border-0' shadow={false}>
                                        <CardBody className='p-0'>
                                            <table className="w-full min-w-[640px] table-auto border">
                                                <thead>
                                                <tr className='bg-gray-50'>
                                                    {["Valor de terreno", "Valor de construcción", "Valor catastral"].map(
                                                        (el) => (
                                                            <th
                                                                key={el}
                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                            >
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    {el}
                                                                </Typography>
                                                            </th>
                                                        )
                                                    )}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50">
                                                        <NumericFormat
                                                            value={adjustedLandVal}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50">
                                                        <NumericFormat
                                                            value={adjustedConstVal}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                    <td className="py-3 px-5 border-b border-blue-gray-50">
                                                        <NumericFormat
                                                            value={newQualification}
                                                            displayType={'text'}
                                                            prefix={'$'}
                                                            thousandSeparator=","
                                                        />
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        <hr className="my-6 border-b-1 border-blue-gray-100"/>
                        <h6 className="text-blue-gray-300 text-sm mt-3 mb-6 font-bold uppercase">
                            NOTAS DE MOVIMIENTOS DEL PREDIO
                        </h6>
                        <div className="flex flex-wrap">
                            <div className="w-full lg:w-12/12 px-0">
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                    >
                                        Notas
                                    </Typography>
                                    <textarea
                                        type="text"
                                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        value={lotNotes}
                                        onChange={(e) => setLotNotes(e.target.value)}
                                        rows="6"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <Button
                            className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                            onClick={() => handleSubmit()}
                            disabled={loaderActive}
                        >
                            GUARDAR
                        </Button>
                        {
                            error && <p style={{color: "red"}}>{error}</p>
                        }
                    </div>
                </div>
            </div>
            <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                <DialogHeader>Guardado</DialogHeader>
                <DialogBody>
                    <Typography>
                        Se actualizo el predio
                    </Typography>
                </DialogBody>
                <DialogFooter>
                    <Button
                        className="bg-green-500 text-white"
                        onClick={() => handleReset()}
                        disabled={loaderActive}
                    >
                        Finalizar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
};

export default ValuesAdjustment;
